import useReveal from "../hooks/useReveal";

/* Approved client testimonials — wording must not be edited. */
export const REVIEWS = {
    hooper: {
        id: "hooper",
        quote:
            "\u201CI have found SRM to be very helpful, punctual and quick to provide comprehensive reports following their inspections. They have also been ready to assist whenever needed, including attending a body corporate meeting to answer committee questions regarding their findings. I would recommend their services.\u201D",
        name: "Vivienne Hooper",
        lines: ["Senior Strata Manager"],
    },
    lloyd: {
        id: "lloyd",
        quote:
            "\u201CWe have utilised SRM\u2019s Stage 1 inspection and report and are very pleased with the quality and comprehensiveness of the report. We plan to have SRM assist with management of the roof works in future.\u201D",
        name: "Bob Lloyd",
        lines: ["Chair", "The Body Corporate for Blue on Blue", "CTS 37149"],
    },
};

const EYEBROW =
    "font-display font-bold tracking-[0.26em] uppercase text-srm-gold text-[12px] lg:text-[13px]";
const GOLD_RULE = "block h-[3px] w-16 bg-srm-gold";
const H2 =
    "font-display font-bold text-[1.55rem] sm:text-[1.9rem] lg:text-[2.2rem] tracking-[-0.02em] leading-[1.18] text-srm-navy text-balance";

export function ReviewCard({ review, testid }) {
    return (
        <figure
            data-testid={testid}
            className="reveal relative flex h-full flex-col overflow-hidden rounded-xl bg-white ring-1 ring-srm-line px-6 py-6 sm:px-7 sm:py-7 lg:px-8 lg:py-8 shadow-[0_3px_14px_rgba(15,40,86,0.04)]"
        >
            <span aria-hidden className="pointer-events-none absolute left-0 top-0 h-[3px] w-12 bg-srm-gold" />
            <blockquote
                data-testid={`${testid}-quote`}
                className="text-[14.5px] lg:text-[15.5px] text-srm-body leading-[1.75]"
            >
                <p>{review.quote}</p>
            </blockquote>
            <figcaption
                data-testid={`${testid}-attribution`}
                className="mt-auto pt-5 sm:pt-6"
            >
                <span aria-hidden className="block border-t border-srm-line mb-4 sm:mb-5" />
                <div className="font-display font-bold text-srm-navy text-[15px] lg:text-[15.5px] leading-tight">
                    {review.name}
                </div>
                {review.lines.map((l) => (
                    <div
                        key={l}
                        className="mt-1 text-[12.5px] lg:text-[13px] text-srm-body/85 leading-[1.5]"
                    >
                        {l}
                    </div>
                ))}
            </figcaption>
        </figure>
    );
}

/* Homepage — two endorsements, side-by-side on desktop, stacked on mobile. */
export function HomeClientExperience() {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            data-testid="home-client-experience"
            aria-labelledby="home-client-experience-heading"
            className="bg-white border-t border-srm-line"
        >
            <div className="container-srm py-14 sm:py-16 lg:py-20">
                <div className="max-w-3xl mx-auto text-center reveal">
                    <div className={EYEBROW}>Client Experience</div>
                    <span aria-hidden className={`mx-auto mt-4 sm:mt-5 ${GOLD_RULE}`} />
                    <h2 id="home-client-experience-heading" className={`mt-6 sm:mt-8 ${H2}`}>
                        Trusted where the decisions matter.
                    </h2>
                    <p className="mt-4 sm:mt-5 text-[14.5px] sm:text-[15.5px] lg:text-[16px] text-srm-body leading-[1.75]">
                        Independent advice is most valuable when it helps managers
                        and committees make clearer decisions.
                    </p>
                </div>
                <div className="mt-8 sm:mt-10 lg:mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6 max-w-5xl mx-auto">
                    <ReviewCard review={REVIEWS.hooper} testid="home-review-hooper" />
                    <ReviewCard review={REVIEWS.lloyd} testid="home-review-lloyd" />
                </div>
            </div>
        </section>
    );
}

/* Single compact testimonial block for inner pages. */
export function SingleReviewBlock({ review, heading, testid }) {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            data-testid={testid}
            aria-labelledby={`${testid}-heading`}
            className="bg-[#F7F5F0] border-t border-srm-line"
        >
            <div className="container-srm py-14 sm:py-16 lg:py-20">
                <div className="max-w-3xl mx-auto">
                    <div className="text-center reveal">
                        <span aria-hidden className={`mx-auto ${GOLD_RULE}`} />
                        <h2 id={`${testid}-heading`} className={`mt-6 sm:mt-7 ${H2}`}>
                            {heading}
                        </h2>
                    </div>
                    <div className="mt-8 sm:mt-10">
                        <ReviewCard review={review} testid={`${testid}-card`} />
                    </div>
                </div>
            </div>
        </section>
    );
}
